import { RenderersUIType } from "@home-health-notify/domain";
import {
  and,
  ControlProps,
  RankedTester,
  rankWith,
  schemaTypeIs,
  uiTypeIs,
} from "@jsonforms/core";
import { withJsonFormsControlProps } from "@jsonforms/react";
import { FormLabel } from "@mui/material";
import React from "react";

const DataLabelRenderer = ({ data }: ControlProps) => {
  return <FormLabel>{data}</FormLabel>;
};

export const dataLabelTester: RankedTester = rankWith(
  5,
  and(uiTypeIs(RenderersUIType.DataLabel), schemaTypeIs("string")),
);

export default withJsonFormsControlProps(DataLabelRenderer);
